import * as React from "react";

type HouseProps = {
  fillColor?: string;
  height?: string;
  width?: string;
};

const House = ({ fillColor = "#231815", width = "49.411", height = "38.234" }: HouseProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 49.411 33.242">
    <g id="house" transform="translate(0 0)">
      <g id="グループ_2233" data-name="グループ 2233">
        <path id="パス_2287" data-name="パス 2287" d="M3,14.615,24.706,3.195,46.414,14.616a1.5,1.5,0,0,0,1.4-2.655L25.4.172a1.5,1.5,0,0,0-1.4,0L1.6,11.96A1.5,1.5,0,0,0,3,14.615Z" fill={fillColor}/>
        <path id="パス_2288" data-name="パス 2288" d="M47.911,30.241h-5.3V15.579a1.5,1.5,0,0,0-3,0V30.242H26.237V19.373a1.5,1.5,0,0,0-1.5-1.5h-8.9a1.5,1.5,0,0,0-1.5,1.5V30.242H9.8V15.579a1.5,1.5,0,0,0-3,0V30.242H1.5a1.5,1.5,0,1,0,0,3H47.911a1.5,1.5,0,1,0,0-3ZM17.337,20.872h5.9v9.369h-5.9Z" fill={fillColor}/>
      </g>
    </g>
  </svg>
  );
};

export default House;
